// extracted by mini-css-extract-plugin
export default {"GetCurrentLocationIcon":"PlaceAutocompete_GetCurrentLocationIcon__hi0TM"};